export enum ProjectViewAccess {

    PUBLIC      = 'public',
    PRIVATE     = 'private'

}